export const QUICKSTART_DASHBOARD_NAME = 'InfluxDB OSS Metrics'
